import './App.css';
import React, { useState, useEffect } from 'react'
import Fade from 'react-reveal/Fade'

const information = [
  'Bqre',
  '16 Years Old',
  'from Israel',
  'a Computer Science student',
  'a dog lover',
  'an aspiring Programmer'
]

function Home() {
  const [info, setInfo] = useState(0)

  useEffect(() => {
    let count = 0;
    setInterval(() => {
      count++
      if (count < information.length) setInfo(prevInfo => prevInfo + 1)
      else {
        setInfo(0)
        count = 0
      }
    }, 5000)
  }, [])

  return (
    <div>
      <Fade left>
      <h1>Hello, I am <span class="text-warning">{information[info]}</span></h1>
      <p class="lead my-4">
        Hello there, fellow user, and welcome to my website.
        It's a pleasure to have you here!
        Perhaps it is time we both get to meet each other?
      </p>
      </Fade>
      <button class="button btn-warning btn-lg mt-5" onClick={() => {window.location.href="#about"}}>Get to know me.</button>
    </div>
  )
}

function Contact() {
  const [media, setMedia] = useState(0)

  const medias = [
    <a href="https://twitter.com/@BqreXD" rel="noreferrer" target="_blank"><i class="bi bi-twitter"></i> Twitter</a>,
    <h2><i class="bi bi-discord"></i> Bqre#0001</h2>,
    <a href="https://twitter.com/@BqreXD" rel="noreferrer" target="_blank"><i class="bi bi-linkedin"></i> LinkedIn</a>
  ]

  useEffect(() => {
    let count = 0;
    setInterval(() => {
      count++
      if (count < medias.length) setMedia(prevMedia => prevMedia + 1)
      else {
        setMedia(0)
        count = 0
      }
    }, 5000)
  }, [])

  return (
    <h2 class="text-primary">{medias[media]}</h2>
  )
}

export { Home as default, Contact }